// actions
const SET = "orderStatuses/SET";
const SET_FILTERS = "orderStatuses/SET_FILTERS";
const SET_SELECTED_FILTERS = "orderStatuses/SET_SELECTED_FILTERS";
const SET_NEXT_TOKEN = "orderStatuses/SET_NEXT_TOKEN";

const DEFAULT_STATE = {
  listing: [],
  filters: [],
  selectedFilters: [],

  nextToken: null,
  nextNextToken: undefined,
  previousTokens: [],
};

// reducer
const reducer = (state = DEFAULT_STATE, action: any = {}) => {
  switch (action.type) {
    case SET:
      return Object.assign({}, state, { listing: action.listing });
    case SET_SELECTED_FILTERS:
      return Object.assign({}, state, { selectedFilters: action.listing });
    case SET_FILTERS:
      return Object.assign({}, state, { filters: action.filters });
    case SET_NEXT_TOKEN:
      return Object.assign({}, state, { nextToken: action.id });
    default:
      return state;
  }
};

export default reducer;

// action creators
export const setListing = (listing: any[]) => ({ listing, type: SET });
export const setFilters = (filters: string[]) => ({
  filters,
  type: SET_FILTERS,
});
export const setSelectedFilters = (listing: any[]) => ({
  listing,
  type: SET_SELECTED_FILTERS,
});
export const setNextToken = (id: any) => ({ id, type: SET_NEXT_TOKEN });
